import axios from "axios";
import authHeader from "./auth-header";

const REPORT_API_URL = process.env.REACT_APP_API_URL + "/api/reports/";

const getWorkstationIpConflictDetails = (clientId, conflictDate, months, timezone) => {
    return axios.get(
        `${REPORT_API_URL}workstation-ip-conflict-details`,
        {
            headers: authHeader(),
            params: {
                clientId,
                conflictDate,
                months,
                timezone
            }
        }
    );
};

const getWorkstationAuditDetails = (clientId, workstation, conflictDate, timezone) => {
    return axios.get(
        `${REPORT_API_URL}workstation-audit-details`,
        {
            headers: authHeader(),
            params: {
                clientId,
                workstation,
                conflictDate,
                timezone
            }
        }
    );
};

const reportService = {
    getWorkstationIpConflictDetails,
    getWorkstationAuditDetails,
};

export default reportService;
